import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidDataHighCoverage",
  "use": "SolidDataHighCoverage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidDataHighCoverage\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm2.831 5.336a1.125 1.125 0 0 1 1.599 1.583l-4.93 4.978c-.07.071-.147.13-.23.18a1.125 1.125 0 0 1-1.38-.167l-2.435-2.436a1.125 1.125 0 0 1 1.591-1.59l1.64 1.639 4.145-4.187Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol